exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".confirmation__dialog{padding:24px}.confirmation__action{margin-top:16px;text-align:right}.confirmation__title{margin-bottom:16px;margin-top:0}.confirmation__action-button--yes,.confirmation__action-button--yes:hover{color:#ff2e1e}.confirmation__action-button--no{margin-left:12px}.confirmation__action-button--no,.confirmation__action-button--no:hover{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Confirmation/Confirmation.scss
// module id = 791
// module chunks = 0 1